import { render } from "./AlertSettingForm.vue?vue&type=template&id=8789fe76&scoped=true"
import script from "./AlertSettingForm.vue?vue&type=script&lang=js"
export * from "./AlertSettingForm.vue?vue&type=script&lang=js"

import "./AlertSettingForm.vue?vue&type=style&index=0&id=8789fe76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8789fe76"]])

export default __exports__